<template>
  <v-text-field
    v-model="inputVal"
    v-bind="$props"
    autocomplete="off"
    background-color="secondary"
  />
</template>

<script>
export default {
    name: "PsTextfield",
    props: {
        id: {
            type: String,
            required: true
        },
        appendIcon: {
            type: String,
            default: ""
        },
        height: {
            type: String,
            default: ""
        },
        backgroundColor: {
            type: String,
            default: "#003F64"
        },
        color: {
            type: String,
            default: "#003F64"
        },
        prependIcon: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true,
            default: ""
        },
        value: {
            type: String,
            required: false,
            default: ""
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        },
        outlined: {
            type: Boolean,
            required: false,
            default: false
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessages: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: () => ({
        inputVal: ""
    }),
    watch: {
        inputVal (val) {
            this.$emit("input", val);
        }
    }
};
</script>

<style>
</style>
